import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Store from "@/pages/Store";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Store />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#18161d",
            border: "1px solid #2e2a36",
            color: "#f3f4f6",
            fontFamily: "Chivo Mono, monospace",
          },
        }}
      />
    </div>
  );
}

export default App;
